import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Message } from 'semantic-ui-react'
import css from './Notification.module.sass'

class Notification extends Component {
  componentWillReceiveProps (nextProps) {
    if (nextProps.notificationStatus) {
      setTimeout(() => {
        this.props.setNotificationStatus({ notificationStatus: null })
      }, 5000)
    }
  }

  render () {
    const { notificationStatus } = this.props

    if (!notificationStatus) return null

    let title = ''
    let content = ''
    let status = ''

    switch (notificationStatus) {
      case 'isProcessing':
        title = 'Задача поставлена успешно на обработку'
        content = 'Уведомление о статусе выполнения задачи будет отправлено в Slack канал: #media-tq'
        status = 'positive'
        break
      case 'progress':
        title = 'Задача обрабатывается...'
        status = 'warning'
        break
      case 'failedReadEvents':
        title = 'Не удалось получить мета-файл'
        content = 'Мета-файл по указанной ссылке на найден или не существует в хранилище по умолчанию'
        status = 'negative'
        break
      case 'failedGetMedia':
        title = 'Не удалось получить видео-файл'
        content = 'Видео-файл по указанной ссылке на найден или не существует в хранилище по умолчанию'
        status = 'negative'
        break
      case 'badMeta':
        title = 'Не корректный мета-файл'
        content = 'Проверьте наличие и последовательность меток cut-start / cut-stop'
        status = 'negative'
        break
      case 'networkError':
        title = 'Не удалось выполнить операцию'
        content = 'Проверьте наличие интернет-соединения'
        status = 'negative'
        break
    }

    return (
      <div className={css.notification}>
        <Message
          positive={status === 'positive'}
          negative={status === 'negative'}
          warning={status === 'warning'}
        >
          <Message.Header>{title}</Message.Header>
          <p>{content}</p>
        </Message>
      </div>
    )
  }
}

const { func, string } = PropTypes

Notification.propTypes = {
  notificationStatus: string,
  setNotificationStatus: func.isRequired
}

export default Notification



// WEBPACK FOOTER //
// ./src/components/Notification/Notification.js